import React from "react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { makeStyles } from "tss-react/mui";
import { OutlinedButton } from "../button/Buttons.js";
import "../button/EditButton.js";
const useStyles = makeStyles()((theme) => ({
  navigationButton: {
    padding: theme.spacing(0.5),
    minWidth: "auto",
    height: "auto",
    border: "1px solid #E1E7EB",
    '&[aria-disabled="true"]': {
      opacity: 0.25
    },
    '&:hover:not([aria-disabled="true"])': {
      backgroundColor: "rgb(20, 111, 249)",
      color: theme.palette.primary.contrastText
    },
    '&:active[aria-disabled="true"],&:focus[aria-disabled="true"],&:hover[aria-disabled="true"]': {
      border: "1px solid #E1E7EB",
      color: theme.palette.text.primary
    }
  },
  chevron: {
    width: 16,
    height: 16
  }
}));
function PreviousMonthButton({ disabled, ...props }) {
  const { classes } = useStyles();
  return /* @__PURE__ */ React.createElement(OutlinedButton, { ...props, disabled, className: classes.navigationButton, color: "primary" }, /* @__PURE__ */ React.createElement(ChevronLeft, { className: classes.chevron }));
}
function NextMonthButton({ disabled, ...props }) {
  const { classes } = useStyles();
  return /* @__PURE__ */ React.createElement(OutlinedButton, { ...props, disabled, className: classes.navigationButton, color: "primary" }, /* @__PURE__ */ React.createElement(ChevronRight, { className: classes.chevron }));
}
export {
  NextMonthButton,
  PreviousMonthButton
};
//# sourceMappingURL=DatePickerNavButtons.js.map
